module.exports = __webpack_public_path__ + "static/img/banner.5057c66.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/AntiFake08/banner.png
// module id = mYpj
// module chunks = 1